import _ from 'lodash'

/**
 * @param urlParameters {{value: string, key: string}[]}
 * @returns {string|undefined}
 */
function encodeUrlParameters(urlParameters = []) {
	if (_.isEmpty(urlParameters)) return

	let urlParams = new URLSearchParams()
	_.each(urlParameters, param => {
		urlParams.append(param.key, param.value)
	})
	return urlParams.toString()
}

function encodeUrlParametersFromObject(urlParameters = {}) {
	if (_.isEmpty(urlParameters)) return

	const keyValuePairs = []
	_.forOwn(urlParameters, (value, key) => {
		keyValuePairs.push({ key, value })
	})
	return encodeUrlParameters(keyValuePairs)
}

/**
 * @param urlParametersString {string} - e.g. "key1=value1&key2=value2"
 * @returns {Object.<string, string> | undefined}
 */
function decodeUrlParameters(urlParametersString) {
	if (_.isEmpty(urlParametersString)) return

	const urlParams = new URLSearchParams(urlParametersString)
	const urlParameters = {}
	urlParams.forEach((value, key) => {
		urlParameters[key] = value
	})
	return urlParameters
}

/**
 * @param urlParametersString
 * @returns {{value: string, key: string}[] | undefined
 */
function decodeUrlParametersToKeyValuePairs(urlParametersString) {
	if (_.isEmpty(urlParametersString)) return

	const urlParams = decodeUrlParameters(urlParametersString)
	return _.map(urlParams, (value, key) => {
		return { key, value }
	})
}

/**
 * @param httpRequestHeaders {{value: string, key: string}[]}
 * @returns {string|undefined}
 */
function encodeHttpRequestHeaders(httpRequestHeaders = []) {
	if (_.isEmpty(httpRequestHeaders)) return

	return _.map(httpRequestHeaders, header => {
		return `${header.key}: ${header.value}`
	}).join('\n')
}

/**
 * @param httpRequestHeaders {Object.<string, string>}
 * @returns {string|undefined}
 */
function encodeHttpRequestHeadersFromObject(httpRequestHeaders = {}) {
	if (_.isEmpty(httpRequestHeaders)) return

	const keyValuePairs = []
	_.forOwn(httpRequestHeaders, (value, key) => {
		keyValuePairs.push({ key, value })
	})
	return encodeHttpRequestHeaders(keyValuePairs)
}

/**
 * @param httpRequestHeaders {string[]|string}
 * @returns {{value: string, key: string}[]}
 */
function getHttpHeadersAsKeyValuePairs(httpRequestHeaders = []) {
	if (typeof httpRequestHeaders === 'string') {
		httpRequestHeaders = httpRequestHeaders.split('\n')
	}

	return _.map(httpRequestHeaders, header => {
		const headerSplit = header.split(':')
		const key = headerSplit[0]
		const value = headerSplit.slice(1).join(':').trim()
		return { key, value }
	})
}

/**
 * @param httpRequestHeaders {string[]|string}
 * @returns {Object.<string, string>}
 */
function getHttpHeadersAsObject(httpRequestHeaders = []) {
	const keyValuePairs = getHttpHeadersAsKeyValuePairs(httpRequestHeaders)
	const headers = {}
	_.each(keyValuePairs, header => {
		headers[header.key] = header.value
	})
	return headers
}

export { encodeUrlParameters }
export { encodeUrlParametersFromObject }
export { decodeUrlParameters }
export { decodeUrlParametersToKeyValuePairs }
export { encodeHttpRequestHeaders }
export { encodeHttpRequestHeadersFromObject }
export { getHttpHeadersAsKeyValuePairs }
export { getHttpHeadersAsObject }